import { DatePickerProps } from '@mui/x-date-pickers/DatePicker/DatePicker.types';
import { lazy, Suspense } from 'react';

const NbDatePickerBase = lazy(() => import('./DatePickerBase'));

interface NbDatePickerProps<TDate extends boolean> extends DatePickerProps<TDate> {
  size?: 'small' | 'normal';
  errorMessage?: string;
}

export const NbDatePicker = <TDate extends boolean>(props: NbDatePickerProps<TDate>) => {
  return (
    <Suspense fallback={null}>
      <NbDatePickerBase {...props} />
    </Suspense>
  );
};
